export function buildCategoryOptions(
  categories: { id: string | number; name: string }[],
  allLabel: string
): { label: string; value: string }[] {
  return [
    { label: allLabel, value: '' },
    ...categories.map((category) => ({
      label: category.name,
      value: String(category.id),
    })),
  ];
}
